import { AfterViewInit, Component, Inject, Input, ViewChild } from '@angular/core';

import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { MessageDialogComponent } from '../../../shared/dialogs/components/message-dialog.component';

import { SubjectRelay } from '../../../shared/commands/subject-relay.class';
import { JSR310ConversionService } from '../../../shared/jsr310-localdates/services/jsr310-conversion.service';

import { JobsFilters } from '../entities/jobs-filters.entity';
import { JobService } from '../services/job.service';
import { PastJobDto } from '../entities/past-job-dto.entity';

type JobDisplay = {
	jobExecutionId: number;
	startDate: Date,
	endDate: Date,
	jobName: string;
	status: string;
	exitMessage: string | null;
}

@Component({
	selector: 'jobs-table',
	templateUrl: 'jobs-table.html',
	styleUrls: ['jobs-table.css']
})
export class JobsTableComponent implements AfterViewInit {
	// Elements de fonctionnement du tableau des memo
	maxSize = 100;
	isLoading: boolean = true;
	displayedColumns: string[] = ['jobExecutionId', 'jobName', 'startDate', 'endDate', 'status', 'buttons'];
	data: PastJobDto[] = [];
	maxSizeExceeded = false;
	dataSource: MatTableDataSource<JobDisplay> = new MatTableDataSource([] as JobDisplay[]);
	
	// Filtres actuellement appliques aux memos
	private appliedFilters!: JobsFilters;

	constructor( //
		private dialog: MatDialog,

		@Inject(JobService) private jobService: JobService,
		@Inject(JSR310ConversionService) public jsr310Service: JSR310ConversionService,
	) {
		this.filters$.subscribe(
			filters => {
				this.appliedFilters = filters;
				this.reloadJobData();
			}
		);
	}

	// Elements injectes necessaires a la gestion du tableau
	@ViewChild(MatPaginator) paginator!: MatPaginator;
	@ViewChild(MatSort) sort!: MatSort;

	// Liaison de l'observable alertant des changements de filtres
	private filters$ = new SubjectRelay<JobsFilters>();
	@Input() set filtersSubject	(obs: Observable<JobsFilters> | undefined) {
		this.filters$.registerSource(obs);
	}
			
	ngAfterViewInit() {
		// Initialisation du dataSource
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;
	}

	private reloadJobData() {
		this.jobService.searchHistory(this.appliedFilters).subscribe(
			(results: PastJobDto[]) => this.displayJobs(results)
		);
	}

	private displayJobs(data: PastJobDto[]) {
		this.data = data;

		// Gestion de la limitation du nombre de resultats
		this.maxSizeExceeded = data.length > this.maxSize;
		if (this.maxSizeExceeded) {
			this.data.splice(this.maxSize);
		}
		
		let displays = this.data.map(
			(job) => ({
				jobExecutionId: job.jobExecutionId,
				startDate: new Date(job.startTimestamp),
				endDate: new Date(job.endTimestamp),
				jobName: job.jobName,
				status: job.status,
				exitMessage: job.exitMessage,
			} as JobDisplay)
		);

		// Mise a jour du dataSource
		this.dataSource.data = displays;

		// Retrait de l'indicateur de chargement
		this.isLoading = false;
	}
	
	displayExitMessage(job: JobDisplay) {
		this.dialog.open(MessageDialogComponent, {
			width: '900px',
			data: {
				title: 'Message de sortie',
				messages: [job.exitMessage]
			}
		});
	}
}